import type { ReactNode } from 'react';

interface LoadingSectionProps {
  isLoading: boolean;
  children: ReactNode;
  className?: string;
  spinnerPosition?: 'top-right' | 'top-left' | 'center';
  overlayStyle?: 'dimmed' | 'blurred';
  allowInteractionWhileLoading?: boolean;
}

export function LoadingSection({
  isLoading,
  children,
  className = '',
  spinnerPosition = 'top-right',
  overlayStyle = 'dimmed',
  allowInteractionWhileLoading = false,
}: LoadingSectionProps) {
  const positionClasses = {
    'top-right': 'top-2 right-2',
    'top-left': 'top-2 left-2',
    center: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  };

  return (
    <div className={`relative ${className}`}>
      {isLoading && (
        <>
          <div
            className={`absolute ${positionClasses[spinnerPosition]} z-10 ${allowInteractionWhileLoading ? 'pointer-events-none' : ''}`}
          >
            <div className="size-6 border-2 border-teal-400 border-t-transparent rounded-full animate-spin" />
          </div>
          {overlayStyle === 'blurred' && (
            <div
              className={`absolute inset-0 bg-neutral-900/30 backdrop-blur-[1px] rounded-lg z-[5] ${allowInteractionWhileLoading ? 'pointer-events-none' : ''}`}
            />
          )}
        </>
      )}
      <div
        className={`transition-opacity duration-200 ${isLoading ? 'opacity-40' : 'opacity-100'}`}
      >
        {children}
      </div>
    </div>
  );
}
